import React, { Fragment } from 'react';
import { format } from 'date-fns';
import renderNode from '../components/renderNode';
import { Label } from './Common';
import parseJson from '../utils/parseJson';
import useHasAccessRight from '../../../../hooks/useHasAccessRight';
import useDebugMode from '../../../../hooks/useDebugMode';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import NoPermissionText from '../../../NoPermissionText';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  blurred: {
    filter: 'blur(1.5rem)',
  },
}));

const QuestionnaireAnswersPreview = ({ questions, answers, submittedAt, children }: any) => {
  const classes = useStyles();
  const hasAccessRight = useHasAccessRight();
  const { canBypassPermissions } = useDebugMode();
  const isAllowedToView = hasAccessRight('patient.view') || canBypassPermissions;

  return (
    <Fragment>
      {answers ? (
        <Accordion square elevation={0}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
            {children}
            {submittedAt && (
              <Label>
                Submitted on {format(submittedAt, 'MM/DD/YYYY')} at {format(submittedAt, 'HH:mm:ss')}
              </Label>
            )}
          </AccordionSummary>
          <AccordionDetails className={clsx({ [classes.root]: !isAllowedToView })}>
            <Box>
              {!isAllowedToView && <NoPermissionText withText={true} style={{ top: '50%', left: '30%' }} />}
              <Box className={clsx({ [classes.blurred]: !isAllowedToView })}>
                {renderNode(parseJson(questions), { value: parseJson(answers) })}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      ) : (
        <Label style={{ marginBottom: 0, marginLeft: 0, marginRight: 'auto' }}>
          Waiting for patient to fill the form
        </Label>
      )}
    </Fragment>
  );
};

export default QuestionnaireAnswersPreview;
